<template>
  <v-form v-model="form" max-width="1500px">
    <v-card flat>
      <v-toolbar class="headline" color="primary" dark>{{ title }}</v-toolbar>
      <v-card-text>
        <v-form ref="p2DialogForm" v-model="valid" lazy-validation>
          <v-container>
            <template v-if="condition">
              <v-card class="RiyoushaBox">
                <v-card-title>
                  <h5>ユーザ情報</h5>
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col>
                      <ryou-input
                        v-model="model.user_id"
                        :value="model.user_id"
                        :label="'*ユーザID'"
                        :rules="userIdRules"
                        :disabled="disUserId"
                        :maxlength="10"
                      >
                      </ryou-input>
                    </v-col>
                    <v-col>
                      <ryou-input
                        v-model="model.user_name"
                        :value="model.user_name"
                        :label="'*ユーザ名'"
                        :rules="userNameRules"
                        :maxlength="30"
                        :disabled="userDisab"
                      >
                      </ryou-input>
                    </v-col>
                    <v-col>
                      <ryou-input
                        v-model="model.user_name_kana"
                        :value="model.user_name_kana"
                        :label="'*ユーザ名ｶﾅ'"
                        :rules="userNaKaRules"
                        :maxlength="30"
                        :disabled="userDisab"
                      >
                      </ryou-input>
                    </v-col>
                    <v-col>
                      <ryou-input
                        v-model="model.affiliation"
                        :value="model.affiliation"
                        :label="'所属'"
                        :maxlength="32"
                        :disabled="userDisab"
                      >
                      </ryou-input>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <ryou-date-format
                        v-model="model.birthday"
                        :value="model.birthday"
                        :disabled="userDisab"
                        :type="'date'"
                        :format="'$1/$2/$3'"
                        :label="'生年月日'"
                        :rules="birthdayRules"
                      >
                      </ryou-date-format>
                    </v-col>
                    <v-col>
                      <ryou-select
                        v-model="selectUserClass"
                        :value="selectUserClass"
                        :label="'*利用者区分'"
                        :items="userClassItems"
                        :itemText="'code_text'"
                        :itemValue="'code_value'"
                        :rules="classRules"
                        :disabled="updateDisflg"
                      >
                      </ryou-select>
                    </v-col>
                    <v-col>
                      <ryou-select
                        v-model="selectSex"
                        :value="selectSex"
                        :label="'性別'"
                        :items="sexItems"
                        :itemText="'code_text'"
                        :itemValue="'code_value'"
                        :disabled="userDisab"
                      >
                      </ryou-select>
                    </v-col>
                    <v-col>
                      <ryou-select
                        v-model="selectBlood"
                        :value="selectBlood"
                        :label="'血液型'"
                        :items="bloodItems"
                        :itemText="'code_text'"
                        :itemValue="'code_value'"
                        :disabled="userDisab"
                      >
                      </ryou-select>
                    </v-col>
                    <v-col>
                      <ryou-select
                        v-model="selectCompany"
                        :value="selectCompany"
                        :label="'会社選択'"
                        :items="companyItems"
                        :itemText="'code_text'"
                        :itemValue="'code_value'"
                        :rules="companyRules"
                        :disabled="userDisab"
                      >
                      </ryou-select>
                    </v-col>
                    <v-spacer></v-spacer>
                  </v-row>
                  <v-row>
                    <v-col cols="3">
                      <ryou-input
                        v-model="model.mail_address"
                        :value="model.mail_address"
                        :label="'*メールアドレス'"
                        :rules="mailRules"
                        :maxlength="64"
                        :disabled="userDisab"
                      >
                      </ryou-input>
                    </v-col>
                    <v-col cols="3">
                      <ryou-input
                        v-model="model.job_title"
                        :value="model.job_title"
                        :label="'職務名称'"
                        :maxlength="5"
                        :disabled="userDisab"
                      >
                      </ryou-input>
                    </v-col>
                    <v-col cols="3">
                      <ryou-input
                        v-model="model.card_no"
                        :value="model.card_no"
                        :label="'カードID'"
                        :rules="cardNoRules"
                        :appendIcon="
                          $cardType == 'Felica' ? 'mdi-credit-card-plus' : ''
                        "
                        :click-icon-function="clickIcon"
                        :maxlength="16"
                        :disabled="userDisab"
                      >
                      </ryou-input>
                    </v-col>
                    <!-- <v-col cols="3">
                      <ryou-input
                        v-model="model.auth_key"
                        :value="model.auth_key"
                        :label="'認証キー'"
                        :rules="authKeyRules"
                        :maxlength="4"
                      >
                      </ryou-input>
                    </v-col> -->
                  </v-row>
                  <v-row>
                    <v-col>
                      <ryou-textarea
                        v-model="model.remark"
                        :value="model.remark"
                        :label="'特記事項'"
                        :maxlength="128"
                        :outlined="true"
                        :disabled="userDisab"
                      >
                      </ryou-textarea>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </template>
            <template v-if="!condition">
              <v-card class="RiyoushaBox">
                <v-card-title>
                  <h5>ユーザ情報</h5>
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col>
                      <ryou-input
                        v-model="model.user_id"
                        :value="model.user_id"
                        :label="'ユーザID'"
                        :rules="userIdRules"
                        :disabled="disUserId"
                        :maxlength="10"
                      >
                      </ryou-input>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <ryou-input
                        v-model="model.user_name"
                        :value="model.user_name"
                        :label="'ユーザ名'"
                        :rules="userNameRules"
                        :maxlength="30"
                        :disabled="userDisab"
                      >
                      </ryou-input>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <ryou-input
                        v-model="model.user_name_kana"
                        :value="model.user_name_kana"
                        :label="'ユーザ名ｶﾅ'"
                        :rules="userNaKaRules"
                        :maxlength="30"
                        :disabled="userDisab"
                      >
                      </ryou-input>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <ryou-input
                        v-model="model.affiliation"
                        :value="model.affiliation"
                        :label="'所属'"
                        :maxlength="32"
                        :disabled="userDisab"
                      >
                      </ryou-input>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <ryou-date-format
                        v-model="model.birthday"
                        :value="model.birthday"
                        :rules="birthdayRules"
                        :type="'date'"
                        :format="'$1/$2/$3'"
                        :label="'生年月日'"
                        :disabled="userDisab"
                      >
                      </ryou-date-format>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <ryou-select
                        v-model="selectUserClass"
                        :value="selectUserClass"
                        :label="'利用者区分'"
                        :items="userClassItems"
                        :itemText="'code_text'"
                        :itemValue="'code_value'"
                        :rules="classRules"
                        :disabled="updateDisflg"
                      >
                      </ryou-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <ryou-select
                        v-model="selectSex"
                        :value="selectSex"
                        :label="'性別'"
                        :items="sexItems"
                        :itemText="'code_text'"
                        :itemValue="'code_value'"
                        :disabled="userDisab"
                      >
                      </ryou-select>
                    </v-col>
                    <v-col>
                      <ryou-select
                        v-model="selectBlood"
                        :value="selectBlood"
                        :label="'血液型'"
                        :items="bloodItems"
                        :itemText="'code_text'"
                        :itemValue="'code_value'"
                        :disabled="userDisab"
                      >
                      </ryou-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <ryou-select
                        v-model="selectCompany"
                        :value="selectCompany"
                        :label="'会社選択'"
                        :items="companyItems"
                        :itemText="'code_text'"
                        :itemValue="'code_value'"
                        :rules="companyRules"
                        :disabled="userDisab"
                      >
                      </ryou-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <ryou-input
                        v-model="model.mail_address"
                        :value="model.mail_address"
                        :label="'*メールアドレス'"
                        :rules="mailRules"
                        :maxlength="64"
                        :disabled="userDisab"
                      >
                      </ryou-input>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <ryou-input
                        v-model="model.job_title"
                        :value="model.job_title"
                        :label="'職務名称'"
                        :maxlength="5"
                        :disabled="userDisab"
                      >
                      </ryou-input>
                    </v-col>
                  </v-row>
                  <v-row>
                    <!-- <v-col cols="3">
                      <ryou-input
                        v-model="model.auth_key"
                        :value="model.auth_key"
                        :label="'認証キー'"
                        :rules="authKeyRules"
                        :maxlength="4"
                      >
                      </ryou-input>
                    </v-col> -->
                  </v-row>
                  <v-row>
                    <v-col>
                      <ryou-textarea
                        v-model="model.remark"
                        :value="model.remark"
                        :label="'特記事項'"
                        :maxlength="128"
                        :outlined="true"
                        :disabled="userDisab"
                      >
                      </ryou-textarea>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </template>
            <template v-if="condition">
              <v-card class="RiyoushaBox">
                <v-card-title>
                  <h5>連絡先情報</h5>
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col>
                      <ryou-input
                        v-model="model.user_const_phone"
                        :value="model.user_const_phone"
                        :label="'本人連絡先'"
                        :rules="phone1Rules"
                        :maxlength="13"
                      >
                      </ryou-input>
                    </v-col>
                    <v-col>
                      <ryou-input
                        v-model="model.user_const_address"
                        :value="model.user_const_address"
                        :label="'本人連絡先住所'"
                        :maxlength="64"
                      >
                      </ryou-input>
                    </v-col>
                    <v-col>
                      <ryou-input
                        v-model="model.user_const_remark"
                        :value="model.user_const_remark"
                        :label="'本人連絡先備考'"
                        :maxlength="50"
                      >
                      </ryou-input>
                    </v-col>
                    <v-spacer></v-spacer>
                  </v-row>
                  <v-row>
                    <v-col>
                      <ryou-input
                        v-model="model.other1_const_phone"
                        :value="model.other1_const_phone"
                        :label="'その他１連絡先'"
                        :rules="phone2Rules"
                        :maxlength="13"
                      >
                      </ryou-input>
                    </v-col>
                    <v-col>
                      <ryou-input
                        v-model="model.other1_const_address"
                        :value="model.other1_const_address"
                        :label="'その他１連絡先住所'"
                        :maxlength="64"
                      >
                      </ryou-input>
                    </v-col>
                    <v-col>
                      <ryou-input
                        v-model="model.other1_const_remark"
                        :value="model.other1_const_remark"
                        :label="'その他１連絡先備考'"
                        :maxlength="50"
                      >
                      </ryou-input>
                    </v-col>
                    <v-spacer></v-spacer>
                  </v-row>
                  <v-row>
                    <v-col>
                      <ryou-input
                        v-model="model.other2_const_phone"
                        :value="model.other2_const_phone"
                        :label="'その他２連絡先'"
                        :rules="phone3Rules"
                        :maxlength="13"
                      >
                      </ryou-input>
                    </v-col>
                    <v-col>
                      <ryou-input
                        v-model="model.other2_const_address"
                        :value="model.other2_const_address"
                        :label="'その他２連絡先住所'"
                        :maxlength="64"
                      >
                      </ryou-input>
                    </v-col>
                    <v-col>
                      <ryou-input
                        v-model="model.other2_const_remark"
                        :value="model.other2_const_remark"
                        :label="'その他２連絡先備考'"
                        :maxlength="50"
                      >
                      </ryou-input>
                    </v-col>
                    <v-spacer></v-spacer>
                  </v-row>
                </v-card-text>
              </v-card>
            </template>
            <template v-if="!condition">
              <v-card class="RiyoushaBox">
                <v-card-title>
                  <h5>連絡先情報</h5>
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col>
                      <ryou-input
                        v-model="model.user_const_phone"
                        :value="model.user_const_phone"
                        :label="'本人連絡先'"
                        :rules="phone1Rules"
                        :maxlength="13"
                      >
                      </ryou-input>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <ryou-input
                        v-model="model.user_const_address"
                        :value="model.user_const_address"
                        :label="'本人連絡先住所'"
                        :maxlength="64"
                      >
                      </ryou-input>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <ryou-input
                        v-model="model.user_const_remark"
                        :value="model.user_const_remark"
                        :label="'本人連絡先備考'"
                        :maxlength="50"
                      >
                      </ryou-input>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <ryou-input
                        v-model="model.other1_const_phone"
                        :value="model.other1_const_phone"
                        :label="'その他１連絡先'"
                        :rules="phone2Rules"
                        :maxlength="13"
                      >
                      </ryou-input>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <ryou-input
                        v-model="model.other1_const_address"
                        :value="model.other1_const_address"
                        :label="'その他１連絡先住所'"
                        :maxlength="64"
                      >
                      </ryou-input>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <ryou-input
                        v-model="model.other1_const_remark"
                        :value="model.other1_const_remark"
                        :label="'その他１連絡先備考'"
                        :maxlength="50"
                      >
                      </ryou-input>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <ryou-input
                        v-model="model.other2_const_phone"
                        :value="model.other2_const_phone"
                        :label="'その他２連絡先'"
                        :rules="phone3Rules"
                        :maxlength="13"
                      >
                      </ryou-input>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <ryou-input
                        v-model="model.other2_const_address"
                        :value="model.other2_const_address"
                        :label="'その他２連絡先住所'"
                        :maxlength="64"
                      >
                      </ryou-input>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <ryou-input
                        v-model="model.other2_const_remark"
                        :value="model.other2_const_remark"
                        :label="'その他２連絡先備考'"
                        :maxlength="50"
                      >
                      </ryou-input>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </template>
            <template v-if="condition">
              <v-row v-if="updateDisflg">
                <v-col cols="5">
                  <v-row class="mt-0 mb-0">
                    <ryou-black-btn
                      :label="'データ切り替え'"
                      :handlerClick="switchTenantData"
                      :iconCls="'mdi-account-box-multiple'"
                      :small="true"
                      :disabled="tenantSwitchBtn"
                    ></ryou-black-btn>
                    <p v-if="!tenantSwitchBtn" class="attention">
                      部屋移動の情報があります
                    </p>
                  </v-row>
                </v-col>
              </v-row>
              <v-card class="RiyoushaBox" :disabled="tenantDisab">
                <v-card-title>
                  <v-row>
                    <v-col cols="1">
                      <h5>寮生情報</h5>
                    </v-col>
                    <v-col cols="2">
                      <h6>
                        <font color="red">{{ tenantCardMessage }}</font>
                      </h6>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col>
                      <ryou-select
                        v-model="selectBuild"
                        :value="selectBuild"
                        :label="label_select_build"
                        :items="buildItems"
                        :itemText="'code_text'"
                        :itemValue="'code_value'"
                        :rules="buildRules"
                      >
                      </ryou-select>
                    </v-col>
                    <v-col>
                      <ryou-select
                        v-model="selectTenant"
                        :value="selectTenant"
                        :label="label_select_tenant"
                        :items="tenantItems"
                        :itemText="'code_text'"
                        :itemValue="'code_value'"
                        :rules="tenantdRules"
                      >
                      </ryou-select>
                    </v-col>
                    <v-col class="roomid">
                      <ryou-input
                        v-model="model.room_id"
                        :value="model.room_id"
                        :label="label_room_id"
                        :prependIcon="'mdi-office-building-outline'"
                        :appendIcon="'mdi-plus-box'"
                        :rules="roomIdRules"
                        :maxlength="10"
                        :click-icon-function="clickRoomSelect"
                      >
                      </ryou-input>
                    </v-col>
                    <v-col class="dateInout">
                      <ryou-date-format
                        v-model="in_dormitory_date"
                        :value="in_dormitory_date"
                        :type="'date'"
                        :format="'$1/$2/$3'"
                        :rules="indateRules"
                        :label="label_in_dormitory_date"
                      >
                      </ryou-date-format>
                    </v-col>
                    <v-col class="dateInout">
                      <ryou-date-format
                        v-model="out_dormitory_date"
                        :value="out_dormitory_date"
                        :type="'date'"
                        :format="'$1/$2/$3'"
                        :min="selectMin"
                        :label="'退寮日'"
                      ></ryou-date-format>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="3">
                      <ryou-input
                        v-model="model.premium_room_rent"
                        :value="model.premium_room_rent"
                        :label="'個人別部屋調整代'"
                        :rules="roomRentRules"
                        :maxlength="6"
                      >
                      </ryou-input>
                    </v-col>
                    <v-col cols="3">
                      <ryou-radio
                        v-model="model.meal_company_burden"
                        :value="model.meal_company_burden"
                        :items="radioItems"
                        :label="'食費会社負担有無'"
                      ></ryou-radio>
                    </v-col>
                    <v-col class="roomid" cols="3" v-if="shoeboxFlg">
                      <ryou-input
                        v-model="model.shoebox_id"
                        :value="model.shoebox_id"
                        :label="'サブエントランス番号'"
                        :prependIcon="'mdi-grid'"
                        :appendIcon="'mdi-plus-box'"
                        :rules="shoeboxIdRules"
                        :maxlength="5"
                        :click-icon-function="clickSubEntranceSelect"
                      >
                      </ryou-input>
                    </v-col>
                    <v-col cols="3">
                      <ryou-input
                        v-model="model.resident_association_exe_cost"
                        :value="model.resident_association_exe_cost"
                        :label="'自治会費免除代'"
                        :rules="residentAssociationExeCostRules"
                        :maxlength="5"
                      >
                      </ryou-input>
                    </v-col>
                    <v-spacer></v-spacer>
                  </v-row>
                  <v-row>
                    <v-col class="radioBtn" cols="3">
                      <ryou-radio
                        v-model="electrical_plan"
                        :value="electrical_plan"
                        :items="eleRadioItems"
                        :label="'電気代個別請求'"
                      ></ryou-radio>
                    </v-col>
                    <v-col cols="3">
                      <ryou-input
                        v-model="model.electrical_use_fee"
                        :value="model.electrical_use_fee"
                        :label="'電気代個別請求料金'"
                        :rules="eleRules"
                        :maxlength="5"
                      >
                      </ryou-input>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="radioBtn" cols="3">
                      <ryou-radio
                        v-model="gas_plan"
                        :value="gas_plan"
                        :items="gasRadioItems"
                        :label="'ガス代個別請求'"
                      >
                      </ryou-radio>
                    </v-col>
                    <v-col cols="3">
                      <ryou-input
                        v-model="model.gas_use_fee"
                        :value="model.gas_use_fee"
                        :label="'ガス代個別請求料金'"
                        :rules="gasRules"
                        :maxlength="5"
                      >
                      </ryou-input>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="radioBtn" cols="3">
                      <ryou-radio
                        v-model="water_plan"
                        :value="water_plan"
                        :items="watRadioItems"
                        :label="'水道代個別請求'"
                      >
                      </ryou-radio>
                    </v-col>
                    <v-col cols="3">
                      <ryou-input
                        v-model="model.water_use_fee"
                        :value="model.water_use_fee"
                        :label="'水道代個別請求料金'"
                        :rules="waterRules"
                        :maxlength="5"
                      >
                      </ryou-input>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </template>
            <template v-if="!condition">
              <v-row>
                <v-col cols="5">
                  <v-row class="mt-0 mb-0">
                    <ryou-black-btn
                      :label="'データ切り替え'"
                      :handlerClick="switchTenantData"
                      :iconCls="'mdi-account-box-multiple'"
                      :small="true"
                      :disabled="tenantSwitchBtn"
                    ></ryou-black-btn>
                    <p v-if="!tenantSwitchBtn" class="attention">
                      部屋移動の情報があります
                    </p>
                  </v-row>
                </v-col>
              </v-row>
              <v-card class="RiyoushaBox" :disabled="tenantDisab">
                <v-card-title>
                  <v-row>
                    <v-col cols="4">
                      <h5>寮生情報</h5>
                    </v-col>
                    <v-col cols="8">
                      <h6>
                        <font color="red">{{ tenantCardMessage }}</font>
                      </h6>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col>
                      <ryou-select
                        v-model="selectBuild"
                        :value="selectBuild"
                        :label="label_select_build"
                        :items="buildItems"
                        :itemText="'code_text'"
                        :itemValue="'code_value'"
                        :rules="buildRules"
                        :disabled="updateDisflg"
                      >
                      </ryou-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <ryou-select
                        v-model="selectTenant"
                        :value="selectTenant"
                        :label="label_select_tenant"
                        :items="tenantItems"
                        :itemText="'code_text'"
                        :itemValue="'code_value'"
                        :rules="tenantdRules"
                      >
                      </ryou-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <ryou-input
                        v-model="model.room_id"
                        :value="model.room_id"
                        :label="label_room_id"
                        :prependIcon="'mdi-office-building-outline'"
                        :appendIcon="'mdi-plus-box'"
                        :rules="roomIdRules"
                        :maxlength="10"
                        :disabled="updateDisflg"
                        :click-icon-function="clickRoomSelect"
                      >
                      </ryou-input>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col v-if="shoeboxFlg">
                      <ryou-input
                        v-model="model.shoebox_id"
                        :value="model.shoebox_id"
                        :label="'サブエントランス番号'"
                        :prependIcon="'mdi-grid'"
                        :appendIcon="'mdi-plus-box'"
                        :rules="shoeboxIdRules"
                        :maxlength="5"
                        :click-icon-function="clickSubEntranceSelect"
                      >
                      </ryou-input>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="dateInout">
                      <ryou-date-format
                        v-model="in_dormitory_date"
                        :value="in_dormitory_date"
                        :type="'date'"
                        :format="'$1/$2/$3'"
                        :rules="indateRules"
                        :label="label_in_dormitory_date"
                      >
                      </ryou-date-format>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="dateInout">
                      <ryou-date-format
                        v-model="out_dormitory_date"
                        :value="out_dormitory_date"
                        :type="'date'"
                        :format="'$1/$2/$3'"
                        :min="selectMin"
                        :label="'退寮日'"
                      ></ryou-date-format>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <ryou-input
                        v-model="model.premium_room_rent"
                        :value="model.premium_room_rent"
                        :label="'個人別部屋調整代'"
                        :rules="roomRentRules"
                        :maxlength="6"
                      >
                      </ryou-input>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col style="margin-top: -30px">
                      <ryou-radio
                        v-model="model.meal_company_burden"
                        :value="model.meal_company_burden"
                        :items="radioItems"
                        :label="'食費会社負担有無'"
                      ></ryou-radio>
                    </v-col>
                  </v-row>
                  <v-col cols="3">
                    <ryou-input
                      v-model="model.resident_association_exe_cost"
                      :value="model.resident_association_exe_cost"
                      :label="'自治会費免除代'"
                      :rules="residentAssociationExeCostRules"
                      :maxlength="5"
                    >
                    </ryou-input>
                  </v-col>
                  <v-row>
                    <v-col style="margin-top: -30px">
                      <ryou-radio
                        v-model="electrical_plan"
                        :value="electrical_plan"
                        :items="eleRadioItems"
                        :label="'電気代個別請求'"
                      ></ryou-radio>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <ryou-input
                        v-model="model.electrical_use_fee"
                        :value="model.electrical_use_fee"
                        :label="'電気代個別請求料金'"
                        :rules="eleRules"
                        :maxlength="5"
                      >
                      </ryou-input>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col style="margin-top: -30px">
                      <ryou-radio
                        v-model="gas_plan"
                        :value="gas_plan"
                        :items="gasRadioItems"
                        :label="'ガス代個別請求'"
                      >
                      </ryou-radio>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <ryou-input
                        v-model="model.gas_use_fee"
                        :value="model.gas_use_fee"
                        :label="'ガス代個別請求料金'"
                        :rules="gasRules"
                        :maxlength="5"
                      >
                      </ryou-input>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col style="margin-top: -30px">
                      <ryou-radio
                        v-model="water_plan"
                        :value="water_plan"
                        :items="watRadioItems"
                        :label="'水道代個別請求'"
                      >
                      </ryou-radio>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <ryou-input
                        v-model="model.water_use_fee"
                        :value="model.water_use_fee"
                        :label="'水道代個別請求料金'"
                        :rules="waterRules"
                        :maxlength="5"
                      >
                      </ryou-input>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </template>
            <v-card
              v-if="!isTenant"
              class="RiyoushaBox"
              :disabled="objectBuildDisab"
            >
              <v-card-title>
                <h5>{{ label_select_group }}</h5>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <template v-if="condition">
                    <v-col cols="6">
                      <ryou-select
                        v-model="selectGroup"
                        :value="selectGroup"
                        :items="objectGroupItems"
                        :itemText="'build_group_name'"
                        :itemValue="'build_group_id'"
                        :rules="objectBuildRules"
                      >
                      </ryou-select>
                    </v-col>
                  </template>
                  <template v-if="!condition">
                    <v-col>
                      <ryou-select
                        v-model="selectGroup"
                        :value="selectGroup"
                        :items="objectGroupItems"
                        :itemText="'build_group_name'"
                        :itemValue="'build_group_id'"
                        :rules="objectBuildRules"
                      >
                      </ryou-select>
                    </v-col>
                  </template>
                </v-row>
              </v-card-text>
            </v-card>
          </v-container>
          <ryou-confirm ref="confirm"></ryou-confirm>
          <read-card ref="card" :setCardNo="setCardNo"></read-card>
          <room-select-dialog
            ref="roomSelect"
            :buildingId="selectBuild"
            :setRoomIdFunc="setRoomIdByChild"
          ></room-select-dialog>
          <sub-entrance-select-dialog
            ref="subEntranceSelect"
            :buildingId="selectBuild"
            :setFunc="setSubEntranceIdByChild"
          ></sub-entrance-select-dialog>
        </v-form>
      </v-card-text>
      <v-card-actions v-show="showbtn">
        <v-spacer></v-spacer>
        <ryou-black-btn
          :label="'閉じる'"
          :handlerClick="handleCancel"
          :iconCls="'mdi-close'"
        ></ryou-black-btn>
        <v-spacer></v-spacer>
        <ryou-black-btn
          :label="'登録'"
          :handlerClick="handleOk"
        ></ryou-black-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import RyouInput from "@/components/formInput/RyouInput.vue";
import RyouDateFormat from "@/components/formInput/RyouDateFormat.vue";
import RyouSelect from "@/components/formInput/RyouSelect.vue";
import RyouRadio from "@/components/formInput/RyouRadio.vue";
import RyouTextarea from "@/components/formInput/RyouTextarea.vue";
import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";
//import RyouAutocomplete from "@/components/formInput/RyouAutocomplete.vue";
import RyouConfirm from "@/components/dialog/RyouConfirm.vue";
import ReadCard from "@/views/user/modules/ReadCard.vue";
import RoomSelectDialog from "@/views/user/modules/RoomSelectDialog.vue";
import SubEntranceSelectDialog from "@/views/user/modules/SubEntranceSelectDialog.vue";
//import { mdiCreditCardPlusOutline } from '@mdi/js';

export default {
  name: "UserChangeInformation",
  components: {
    RyouInput,
    RyouDateFormat,
    RyouSelect,
    RyouRadio,
    RyouTextarea,
    RyouBlackBtn,
    RyouConfirm,
    //RyouAutocomplete,
    ReadCard,
    RoomSelectDialog,
    SubEntranceSelectDialog,
  },
  props: {
    loadFlag: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data: () => ({
    isTenant: false,
    updateDisflg: false,
    targetBuildingId: null,
    targetRoomId: null,
    condition: true,
    tmpMail: "",
    tmpUserClass: "",
    form: true,
    title: "",
    selectMin: "",
    birthData: "",
    valid: true,
    disUserId: false,
    shoeboxFlg: false,
    userDateUpdateFlg: false,
    userDisab: false,
    tenantDisab: false,
    objectBuildDisab: false,
    userIdRules: [],
    userNameRules: [],
    userNaKaRules: [],
    birthdayRules: [],
    classRules: [],
    sexRules: [],
    companyRules: [],
    inputRemarkRules: [],
    mailRules: [],
    jobRules: [],
    phone1Rules: [],
    phone2Rules: [],
    phone3Rules: [],
    roomIdRules: [],
    shoeboxIdRules: [],
    residentAssociationExeCostRules: [],
    roomRentRules: [],
    eleRules: [],
    gasRules: [],
    waterRules: [],
    buildRules: [],
    tenantdRules: [],
    indateRules: [],
    requiredRules: [],
    objectBuildRules: [],
    cardNoRules: [],
    authKeyRules: [],
    userClassItems: [],
    sexItems: [],
    bloodItems: [],
    companyItems: [],
    buildItems: [],
    tenantItems: [],
    objectGroupItems: [],
    selectUserClass: "",
    selectSex: "",
    selectBlood: "",
    selectCompany: "",
    selectBuild: "",
    selectTenant: "",
    selectGroup: "",
    in_dormitory_date: "",
    out_dormitory_date: "",
    electrical_plan: "",
    gas_plan: "",
    water_plan: "",
    roomItems: [],
    radioItems: [
      {
        value: "1",
        label: "あり",
      },
      {
        value: "0",
        label: "なし",
      },
    ],
    eleRadioItems: [
      {
        value: "1",
        label: "あり",
      },
      {
        value: "0",
        label: "なし",
      },
    ],
    gasRadioItems: [
      {
        value: "1",
        label: "あり",
      },
      {
        value: "0",
        label: "なし",
      },
    ],
    watRadioItems: [
      {
        value: "1",
        label: "あり",
      },
      {
        value: "0",
        label: "なし",
      },
    ],
    tenantInfoList: [],
    tenantInfoIdex: -1,
    tenantCardMessage: "",
    tenantSwitchBtn: true,
    label_select_build: "物件名選択",
    label_select_tenant: "寮生区分",
    label_room_id: "部屋番号",
    label_in_dormitory_date: "入寮日",
    label_select_group: "対象物件グループ名選択",
    model: {
      user_id: "",
      user_name: "",
      user_name_kana: "",
      affiliation: "",
      birthday: "",
      remark: "",
      user_const_phone: "",
      user_const_address: "",
      user_const_remark: "",
      mail_address: "",
      job_title: "",
      other1_const_phone: "",
      other1_const_address: "",
      other1_const_remark: "",
      other2_const_phone: "",
      other2_const_address: "",
      other2_const_remark: "",
      room_id: "",
      shoebox_id: "",
      premium_room_rent: "",
      meal_company_burden: "",
      resident_association_exe_cost: "",
      electrical_use_fee: "",
      gas_use_fee: "",
      water_use_fee: "",
      card_no: "",
      // auth_key: "",
    },
  }),
  mounted() {
    if (
      this.$store.getters.getUserClass == "1" ||
      this.$store.getters.getUserClass == "2"
    ) {
      this.userDisab = false;
      this.tenantDisab = false;
      this.objectBuildDisab = false;
      this.userIdRules.push(this.GlobalRules.required);
      this.userIdRules.push(this.GlobalRules.hanAlpha);
      this.userIdRules.push(this.GlobalRules.spec);
      this.userNameRules.push(this.GlobalRules.required);
      this.userNaKaRules.push(this.GlobalRules.required);
      this.userNaKaRules.push(this.GlobalRules.hanKana);
      // this.birthdayRules.push(this.GlobalRules.required);
      this.sexRules.push(this.GlobalRules.required);
      this.classRules.push(this.GlobalRules.required);
      //this.companyRules.push(this.GlobalRules.required);
      this.mailRules.push(this.GlobalRules.required);
      this.mailRules.push(this.GlobalRules.email);
      this.phone1Rules.push(this.GlobalRules.number2);
      this.phone2Rules.push(this.GlobalRules.number2);
      this.phone3Rules.push(this.GlobalRules.number2);
      // 2024.10.10 kouta_noborisaka 部屋番号のルールを変更（最大10文字、半角英数記号(-のみ)チェック） start
      this.roomIdRules.push(this.GlobalRules.counter_10);
      this.roomIdRules.push(this.GlobalRules.hanAlphahyphen);
      // 2024.10.10 kouta_noborisaka 部屋番号のルールを変更（最大10文字、半角英数記号(-のみ)チェック） end
      //this.shoeboxIdRules.push(this.GlobalRules.number3);
      this.roomRentRules.push(this.GlobalRules.number);
      this.jobRules.push(this.GlobalRules.required);
      this.cardNoRules.push(this.GlobalRules.hanAlpha);
      //this.cardNoRules.push(this.GlobalRules.number3);
      this.authKeyRules.push(this.GlobalRules.number3);
      this.authKeyRules.push(this.GlobalRules.number4);
      //this.authKeyRules.push(this.GlobalRules.required);
    } else if (this.$store.getters.getUserClass == "3") {
      this.userDisab = true;
      this.tenantDisab = true;
      this.objectBuildDisab = true;
      this.phone1Rules.push(this.GlobalRules.number2);
      this.phone2Rules.push(this.GlobalRules.number2);
      this.phone3Rules.push(this.GlobalRules.number2);
      // 2024.10.10 kouta_noborisaka 部屋番号のルールを変更（必須、最大10文字、半角英数記号(-のみ)チェック） start
      this.roomIdRules.push(this.GlobalRules.required);
      this.roomIdRules.push(this.GlobalRules.counter_10);
      this.roomIdRules.push(this.GlobalRules.hanAlphahyphen);
      // 2024.10.10 kouta_noborisaka 部屋番号のルールを変更（必須、最大10文字、半角英数記号(-のみ)チェック） end
      this.shoeboxIdRules.push(this.GlobalRules.number3);
      this.roomRentRules.push(this.GlobalRules.number);
      this.cardNoRules.push(this.GlobalRules.hanAlpha);
      //this.cardNoRules.push(this.GlobalRules.number3);
      this.authKeyRules.push(this.GlobalRules.number3);
      this.authKeyRules.push(this.GlobalRules.number4);
      //this.authKeyRules.push(this.GlobalRules.required);
    } else {
      if (
        this.$store.getters.getUserClass == "4" ||
        this.$store.getters.getUserClass == "5"
      ) {
        this.objectBuildDisab = false;
      } else {
        this.objectBuildDisab = true;
      }
      this.userDisab = true;
      this.tenantDisab = true;
      this.phone1Rules.push(this.GlobalRules.number2);
      this.phone2Rules.push(this.GlobalRules.number2);
      this.phone3Rules.push(this.GlobalRules.number2);
    }
  },
  setCardNo(cardNo) {
    // console.log("カードNo" + cardNo);
    this.model.card_no = cardNo;
  },

  computed: {
    showbtn() {
      if (this.loadFlag == true) {
        return true;
      } else {
        return false;
      }
    },
  },
  watch: {
    electrical_plan(val) {
      if (this.selectUserClass == "3" && val == "1") {
        this.eleRules.push(this.GlobalRules.required);
      } else {
        this.eleRules = [];
        this.eleRules.push(this.GlobalRules.currency);
      }
    },
    gas_plan(val) {
      if (this.selectUserClass == "3" && val == "1") {
        this.gasRules.push(this.GlobalRules.required);
      } else {
        this.gasRules = [];
        this.gasRules.push(this.GlobalRules.currency);
      }
    },
    water_plan(val) {
      if (this.selectUserClass == "3" && val == "1") {
        this.waterRules.push(this.GlobalRules.required);
      } else {
        this.waterRules = [];
        this.waterRules.push(this.GlobalRules.currency);
      }
    },
    selectUserClass() {
      if (this.selectUserClass != "" || this.selectUserClass != null) {
        if (this.selectUserClass == "3") {
          this.isTenant = true;
        } else {
          this.isTenant = false;
        }
        this.selectUserClassJudge();
        this.changeRequiredLabel();
      }
    },
    in_dormitory_date(value) {
      if (value != null && value != "") {
        this.selectMin = value;
      } else {
        this.selectMin = "";
      }
      let inDate = new Date(
        Date.parse(this.in_dormitory_date.replace(/-/g, "/"))
      );
      let outDate = new Date(
        Date.parse(this.out_dormitory_date.replace(/-/g, "/"))
      );
      if (inDate.getTime() > outDate.getTime()) {
        this.out_dormitory_date = "";
      }
    },

    tenantInfoIdex(value) {
      if (value != -1) {
        this.selectBuild = this.tenantInfoList[value].selectBuild;
        this.selectTenant = this.tenantInfoList[value].selectTenant;
        this.model.room_id = this.tenantInfoList[value].room_id;
        this.model.shoebox_id = this.tenantInfoList[value].shoebox_id;
        this.in_dormitory_date = this.tenantInfoList[value].in_dormitory_date;
        this.out_dormitory_date = this.tenantInfoList[value].out_dormitory_date;
        this.model.premium_room_rent =
          this.tenantInfoList[value].premium_room_rent;
        this.model.meal_company_burden =
          this.tenantInfoList[value].meal_company_burden;
        this.model.resident_association_exe_cost =
          this.tenantInfoList[value].resident_association_exe_cost;
        this.electrical_plan = this.tenantInfoList[value].electrical_plan;
        this.model.electrical_use_fee =
          this.tenantInfoList[value].electrical_use_fee;
        this.gas_plan = this.tenantInfoList[value].gas_plan;
        this.model.gas_use_fee = this.tenantInfoList[value].gas_use_fee;
        this.water_plan = this.tenantInfoList[value].water_plan;
        this.model.water_use_fee = this.tenantInfoList[value].water_use_fee;

        //部屋移動を検知するためのパラメータ
        this.targetBuildingId = this.selectBuild;
        this.targetRoomId = this.model.room_id;
      }
    },
  },
  created() {
    this.machineModelCheck();
    if (this.loadFlag == true) {
      this.selectedData();
    }
  },
  methods: {
    machineModelCheck() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      if (flag === null || flag === undefined || flag === "") {
        //コンピュータ表示
        this.condition = true;
      } else {
        //スマートフォン表示
        this.condition = false;
      }
    },
    selectedData() {
      var ownflg = true; //自身の情報変更フラグ
      this.edit(this.$store.getters.getUserId, ownflg);
    },
    initData() {
      this.getRequest(
        "/dormitoryUserRevise/selectListGet",
        null,
        this.$store.getters.getUserToken
      ).then((data) => {
        if (data.success) {
          this.sexItems = data.result[0].children; //性別
          this.tenantItems = data.result[1].children; //寮生区分
          this.userClassItems = data.result[2].children; //利用者区分
          this.bloodItems = data.result[3].children; //血液型
        }
      });
      this.getRequest(
        "/dormitoryUserRevise/companyListGet",
        null,
        this.$store.getters.getUserToken
      ).then((data) => {
        if (data.success) {
          this.companyItems = data.result; //会社
          this.companyItems.push("");
        }
      });
      let params = {
        userId: this.$store.getters.getUserId,
        userClass: this.$store.getters.getUserClass,
      };
      this.getRequest(
        "/dormitoryUserRevise/buildGroupGet",
        params,
        this.$store.getters.getUserToken
      ).then((data) => {
        if (data.success) {
          this.objectGroupItems = data.result; //物件グループ名
        }
      });
      this.getRequest(
        "/dormitoryUserRevise/buildListGet",
        params,
        this.$store.getters.getUserToken
      ).then((data) => {
        if (data.success) {
          if (data.result != null) {
            this.buildItems = data.result; //物件名
          } else {
            this.buildItems = [];
            this.buildItems.push("");
          }
        }
      });
      //console.log("物件ID一覧")
      //console.log(this.buildItems)
      //var buildList=[]
      //for (var x in this.buildItems) {
      //  //繰り返し
      //  console.log(x)
      //  buildList.push(x.code_value)
      //  buildList.push("a")
      //}

      //console.log("物件ID一覧")
      //console.log(this.buildItems)
      //console.log("物件１")
      //console.log(this.buildItems[1].code_value)

      setTimeout(() => {}, 100);
    },
    selectUserClassJudge() {
      if (this.selectUserClass == "1" || this.selectUserClass == "2") {
        this.objectBuildRules = [];
        if (this.selectUserClass == "2") {
          this.objectBuildRules.push(this.GlobalRules.required);
        }
        this.residentAssociationExeCostRules = [];
        this.eleRules = [];
        this.gasRules = [];
        this.waterRules = [];
        this.buildRules = [];
        this.tenantdRules = [];
        this.roomIdRules = [];
        this.roomIdRules.push(this.GlobalRules.hanAlphahyphen); // 2024.10.10 kouta_noborisaka 部屋番号のルールを変更（半角英数記号(-のみ)チェック）
        this.indateRules = [];
        this.residentAssociationExeCostRules.push(this.GlobalRules.currency);
        this.eleRules.push(this.GlobalRules.currency);
        this.gasRules.push(this.GlobalRules.currency);
        this.waterRules.push(this.GlobalRules.currency);
      } else if (this.selectUserClass == "3") {
        this.objectBuildRules = [];
        this.buildRules.push(this.GlobalRules.required);
        this.tenantdRules.push(this.GlobalRules.required);
        this.roomIdRules.push(this.GlobalRules.required);
        this.roomIdRules.push(this.GlobalRules.hanAlphahyphen); // 2024.10.10 kouta_noborisaka 部屋番号のルールを変更（半角英数記号(-のみ)チェック）
        this.indateRules.push(this.GlobalRules.required);
        if (this.electrical_plan == "1") {
          this.eleRules.push(this.GlobalRules.required);
          this.eleRules.push(this.GlobalRules.currency);
        } else {
          this.eleRules = [];
          this.eleRules.push(this.GlobalRules.currency);
        }
        if (this.gas_plan == "1") {
          this.gasRules.push(this.GlobalRules.required);
          this.gasRules.push(this.GlobalRules.currency);
        } else {
          this.gasRules = [];
          this.gasRules.push(this.GlobalRules.currency);
        }
        if (this.water_plan == "1") {
          this.waterRules.push(this.GlobalRules.required);
          this.waterRules.push(this.GlobalRules.currency);
        } else {
          this.waterRules = [];
          this.waterRules.push(this.GlobalRules.currency);
        }
      } else {
        if (this.selectUserClass == "4" || this.selectUserClass == "5") {
          this.objectBuildRules = [];
          this.objectBuildRules.push(this.GlobalRules.required);
        } else {
          this.objectBuildRules = [];
        }
        this.residentAssociationExeCostRules = [];
        this.eleRules = [];
        this.gasRules = [];
        this.waterRules = [];
        this.buildRules = [];
        this.tenantdRules = [];
        this.roomIdRules = [];
        this.roomIdRules.push(this.GlobalRules.hanAlphahyphen); // 2024.10.10 kouta_noborisaka 部屋番号のルールを変更（半角英数記号(-のみ)チェック）
        this.residentAssociationExeCostRules.push(this.GlobalRules.currency);
        this.eleRules.push(this.GlobalRules.currency);
        this.gasRules.push(this.GlobalRules.currency);
        this.waterRules.push(this.GlobalRules.currency);
        this.indateRules = [];
      }
    },
    add() {
      this.tenantCardMessage = "";
      this.title = "利用者新規";
      this.initData();
      this.userDateUpdateFlg = false;
      this.disUserId = false;
      this.updateDisflg = false;
      this.model.meal_company_burden = "0";
      this.electrical_plan = "0";
      this.gas_plan = "0";
      this.water_plan = "0";
    },
    edit(record, ownflg) {
      this.open();
      this.title = "利用者修正";
      this.initData();
      this.userDateUpdateFlg = true;
      this.disUserId = true;
      this.updateDisflg = true;
      this.dormitoryUserGet(record, ownflg);
    },
    dormitoryUserGet(record, ownflg) {
      //ウォッチをリセットする
      this.tenantInfoIdex = -1;

      var that = this;
      let params = {};
      if (!ownflg) {
        //寮生一覧から遷移
        params = {
          targetUserId: record.user_id,
          user_id: this.$store.getters.getUserId,
          user_class: this.$store.getters.getUserClass,
        };
      } else {
        //ユーザ情報変更から遷移
        params = {
          targetUserId: record,
          user_id: this.$store.getters.getUserId,
          user_class: this.$store.getters.getUserClass,
        };
      }

      this.getRequest(
        "/dormitoryUserRevise/dormitoryUserGet",
        params,
        this.$store.getters.getUserToken
      ).then((data) => {
        // 利用者情報取得
        if (data.success) {
          //寮生の配列、カードメッセージインデックスをリセット
          that.tenantInfoList = [];
          that.tenantCardMessage = "";

          //ユーザ情報、ユーザ紐づけ情報
          that.model.user_id = data.result[0].user_id;
          that.model.user_name = data.result[0].user_name;
          that.model.user_name_kana = data.result[0].user_name_kana;
          that.model.affiliation = data.result[0].affiliation;
          that.model.birthday = data.result[0].birthday;
          that.birthData = data.result[0].birthday;
          that.selectUserClass = data.result[0].selectUserClass;
          that.selectSex = data.result[0].selectSex;
          that.selectBlood = data.result[0].selectBlood;
          that.selectCompany = data.result[0].selectCompany;
          that.model.card_no = data.result[0].card_no;
          // that.model.auth_key = data.result[0].auth_key;
          that.model.remark = data.result[0].remark;
          that.model.user_const_phone = data.result[0].user_const_phone;
          that.model.user_const_address = data.result[0].user_const_address;
          that.model.user_const_remark = data.result[0].user_const_remark;
          that.model.mail_address = data.result[0].mail_address;
          that.model.other1_const_phone = data.result[0].other1_const_phone;
          that.model.other1_const_address = data.result[0].other1_const_address;
          that.model.other1_const_remark = data.result[0].other1_const_remark;
          that.model.other2_const_phone = data.result[0].other2_const_phone;
          that.model.other2_const_address = data.result[0].other2_const_address;
          that.model.other2_const_remark = data.result[0].other2_const_remark;
          that.model.job_title = data.result[0].job_title;
          that.selectGroup = data.result[0].selectGroup;

          //寮生情報
          that.tenantInfoList = data.result[0].tenants;
          that.tenantInfoIdex = data.result[0].currentTenantIdex;

          that.tenantInfoList.length > 1
            ? (that.tenantSwitchBtn = false)
            : (that.tenantSwitchBtn = true);
          that.setTenantMsg();
        }
      });
    },
    handleOk() {
      this.selectUserClassJudge();
      var valid = this.$refs.p2DialogForm.validate();
      if (valid) {
        if (this.userDateUpdateFlg) {
          this.$refs.confirm
            .open("更新", "更新します。宜しいですか？", { color: "info" })
            .then(async (confirm) => {
              if (confirm) {
                if (this.selectUserClass == 3) {
                  var msg1 = await this.handleRoomWarningCheck(); //部屋警告文取得
                  var msg2 = await this.handleShoeboxWarningCheck(); //靴箱警告文取得
                  var msg = "";
                  msg += msg1 == "" || msg1 == null ? "" : msg1 + "\n";
                  msg += msg2 == "" || msg2 == null ? "" : "\n" + msg2;
                  if (msg != "" && msg != null) {
                    var flg = false;
                    await this.$refs.confirm
                      .open("警告", msg, { color: "warning" })
                      .then((confirm) => {
                        if (!confirm) {
                          flg = true; //キャンセル押下時、それ以降の処理を中断
                        }
                      });

                    if (flg) {
                      return;
                    }
                  }
                }

                //cognito認証機能の有無を判定
                if (this.$getUseCognito()) {
                  this.getRequest(
                    "/api/Users/" + this.model.user_id,
                    null,
                    this.$store.getters.getUserToken
                  )
                    .then((seq) => {
                      this.tmpMail =
                        seq.mail_address == null
                          ? "sample@xxx.xxx"
                          : seq.mail_address; //DB更新失敗時のため、メールアドレスを保持しておく
                      this.tmpUserClass = seq.user_class; //ユーザークラスの保持
                    })
                    .catch((err) => {
                      this.tmpMail = "";
                      // console.log(err);
                    });

                  if (
                    this.$store.getters.getUserClass == 1 ||
                    this.$store.getters.getUserClass == 2
                  ) {
                    this.$cognito
                      .signUp(this.model.user_id, this.model.mail_address, 2)
                      .then((seq) => {
                        //eslint-disable-line
                        //cognitoへのユーザ更新が成功した場合は、グループを更新し、ユーザ情報テーブルを更新する
                        this.$cognito
                          .changeGroup(
                            this.model.user_id,
                            this.selectUserClass,
                            1
                          )
                          .then((res) => {
                            //eslint-disable-line
                            this.updateUserInfo();
                          })
                          .catch((err) => {
                            //cognitoのグループの更新が失敗した場合は変更したメールアドレスをもとに戻す
                            // console.log(err);
                            this.$cognito
                              .signUp(this.model.user_id, this.tmpMail, 2)
                              .then((result) => {
                                //eslint-disable-line
                              })
                              .catch((err) => {
                                // console.log(err);
                              });
                          });
                      })
                      .catch((err) => {
                        //cognitoへのユーザ更新に失敗した場合は、それ以降の処理を中断する
                        // console.log(err);
                      });
                  } else {
                    //総務、管理者以外の場合はcognitoへの更新を行わない
                    this.updateUserInfo();
                  }
                } else {
                  this.updateUserInfo();
                }
              }
            });
        } else {
          this.$refs.confirm
            .open("登録", "登録します。宜しいですか？", { color: "info" })
            .then(async (confirm) => {
              if (confirm) {
                if (this.selectUserClass == 3) {
                  var msg1 = await this.handleRoomWarningCheck(); //部屋警告文取得
                  var msg2 = await this.handleShoeboxWarningCheck(); //靴箱警告文取得
                  var msg = "";
                  msg += msg1 == "" || msg1 == null ? "" : msg1 + "\n";
                  msg += msg2 == "" || msg2 == null ? "" : "\n" + msg2;

                  if (msg != "" && msg != null) {
                    var flg = false;
                    await this.$refs.confirm
                      .open("警告", msg, { color: "warning" })
                      .then((confirm) => {
                        if (!confirm) {
                          flg = true; //キャンセル押下時、それ以降の処理を中断
                        }
                      });

                    if (flg) {
                      return;
                    }
                  }
                }

                //cognito認証機能の有無を判定
                if (this.$getUseCognito()) {
                  this.getRequest(
                    "/dormitoryUserRevise/temporaryPasswordGet",
                    null,
                    this.$store.getters.getUserToken
                  ).then((resp) => {
                    this.$cognito
                      .signUp(
                        this.model.user_id,
                        this.model.mail_address,
                        1,
                        resp.result
                      )
                      .then((seq) => {
                        //cognitoへのユーザ登録が成功した場合は、グループにユーザを登録しユーザ情報テーブルを更新する
                        this.$cognito
                          .changeGroup(
                            this.model.user_id,
                            this.selectUserClass,
                            0
                          )
                          .then((res) => {
                            //eslint-disable-line
                            this.insertUserInfo(seq);
                          })
                          .catch((err) => {
                            //cognitoのグループへの登録が失敗した場合はcognitoに登録したユーザを削除する
                            // console.log(err);
                            this.$cognito
                              .deleteUser(this.model.user_id)
                              .then((result) => {
                                //eslint-disable-line
                              })
                              .catch((err) => {
                                // console.log(err);
                              });
                          });
                        //this.insertUserInfo(seq);
                      })
                      .catch((err) => {
                        //cognitoへのユーザ登録に失敗した場合は、それ以降の処理を中断する
                        // console.log(err);
                      });
                  });
                } else {
                  this.insertUserInfo("nothing");
                }
              }
            });
        }
      }
    },
    insertUserInfo(seq) {
      var that = this;
      let params = {
        loginUserId: this.$store.getters.getUserId,
        user_id: this.model.user_id,
        user_name: this.model.user_name,
        user_name_kana: this.model.user_name_kana,
        affiliation: this.model.affiliation,
        birthday: this.model.birthday,
        selectUserClass: this.selectUserClass,
        selectSex: this.selectSex,
        selectBlood: this.selectBlood,
        selectCompany: this.selectCompany,
        card_no: this.model.card_no,
        // auth_key: this.model.auth_key,
        remark: this.model.remark,
        user_const_phone: this.model.user_const_phone,
        user_const_address: this.model.user_const_address,
        user_const_remark: this.model.user_const_remark,
        mail_address: this.model.mail_address,
        job_title: this.model.job_title,
        other1_const_phone: this.model.other1_const_phone,
        other1_const_address: this.model.other1_const_address,
        other1_const_remark: this.model.other1_const_remark,
        other2_const_phone: this.model.other2_const_phone,
        other2_const_address: this.model.other2_const_address,
        other2_const_remark: this.model.other2_const_remark,
        selectBuild: this.selectBuild,
        selectTenant: this.selectTenant,
        room_id: this.model.room_id,
        shoebox_id: this.model.shoebox_id,
        in_dormitory_date: this.in_dormitory_date,
        out_dormitory_date: this.out_dormitory_date,
        premium_room_rent: this.model.premium_room_rent,
        meal_company_burden: this.model.meal_company_burden,
        resident_association_exe_cost: this.model.resident_association_exe_cost,
        electrical_plan: this.electrical_plan,
        electrical_use_fee: this.model.electrical_use_fee,
        gas_plan: this.gas_plan,
        gas_use_fee: this.model.gas_use_fee,
        water_plan: this.water_plan,
        water_use_fee: this.model.water_use_fee,
        selectGroup: this.selectGroup,
        user_seq_id: seq,
      };
      // 利用者情報登録
      this.postRequest(
        "/dormitoryUserRevise/dormitoryUserInsert",
        params,
        this.$store.getters.getUserToken
      ).then((resp) => {
        if (resp.success) {
          that.$emit("ok");
        } else {
          //cognito認証機能の有無を判定
          if (this.$getUseCognito()) {
            that.$cognito
              .deleteUser(this.model.user_id)
              .then((result) => {
                //eslint-disable-line
              })
              .catch((err) => {
                // console.log(err);
              });
          }
        }
      });
    },
    updateUserInfo() {
      var that = this;
      let params = {
        loginUserId: this.$store.getters.getUserId,
        user_id: this.model.user_id,
        user_name: this.model.user_name,
        user_name_kana: this.model.user_name_kana,
        affiliation: this.model.affiliation,
        birthday: this.model.birthday,
        selectUserClass: this.selectUserClass,
        selectSex: this.selectSex,
        selectBlood: this.selectBlood,
        selectCompany: this.selectCompany,
        remark: this.model.remark,
        card_no: this.model.card_no,
        // auth_key: this.model.auth_key,
        user_const_phone: this.model.user_const_phone,
        user_const_address: this.model.user_const_address,
        user_const_remark: this.model.user_const_remark,
        mail_address: this.model.mail_address,
        job_title: this.model.job_title,
        other1_const_phone: this.model.other1_const_phone,
        other1_const_address: this.model.other1_const_address,
        other1_const_remark: this.model.other1_const_remark,
        other2_const_phone: this.model.other2_const_phone,
        other2_const_address: this.model.other2_const_address,
        other2_const_remark: this.model.other2_const_remark,
        selectBuild: this.selectBuild,
        selectTenant: this.selectTenant,
        room_id: this.model.room_id,
        shoebox_id: this.model.shoebox_id,
        in_dormitory_date: this.in_dormitory_date,
        out_dormitory_date: this.out_dormitory_date,
        premium_room_rent: this.model.premium_room_rent,
        meal_company_burden: this.model.meal_company_burden,
        resident_association_exe_cost: this.model.resident_association_exe_cost,
        electrical_plan: this.electrical_plan,
        electrical_use_fee: this.model.electrical_use_fee,
        gas_plan: this.gas_plan,
        gas_use_fee: this.model.gas_use_fee,
        water_plan: this.water_plan,
        water_use_fee: this.model.water_use_fee,
        selectGroup: this.selectGroup,
        target_building_id:
          this.targetBuildingId != null
            ? this.targetBuildingId.toString()
            : this.selectBuild,
        target_room_id:
          this.targetRoomId != null ? this.targetRoomId : this.model.room_id,
      };

      // 利用者情報更新
      this.putRequest(
        "/dormitoryUserRevise/dormitoryUserUpdate",
        params,
        this.$store.getters.getUserToken
      ).then((resp) => {
        if (resp.success) {
          that.$emit("ok");
        } else {
          //cognito認証機能の有無を判定
          if (this.$getUseCognito()) {
            //DB更新失敗時に保持しておいた更新前のメアドでcognitoのメアドを更新する
            that.$cognito
              .signUp(this.model.user_id, this.tmpMail, 2)
              .then((seq) => {
                //eslint-disable-line
                //DB更新失敗時は保持しておいた更新前のユーザクラスによりcognitoのグループを変更する
                that.$cognito
                  .changeGroup(this.model.user_id, this.tmpUserClass, 2)
                  .then((result) => {
                    //eslint-disable-line
                    // console.log(result);
                  })
                  .catch((err) => {
                    // console.log(err);
                  });
                //console.log(seq);
              })
              .catch((err) => {
                // console.log(err);
              });
          }
        }
      });
    },
    //部屋の使用状況をチェックし警告があれば取得する
    async roomWarningCheck(params) {
      var retMsg; //戻り値（警告文）

      //警告文を取得
      await this.getRequest(
        "/dormitoryUserRevise/roomWarningGet",
        params,
        this.$store.getters.getUserToken
      ).then((data) => {
        if (data.success) {
          retMsg = data.result;
        }
      });

      return retMsg;
    },
    //部屋使用チェックハンドル
    async handleRoomWarningCheck() {
      let params = {
        buildingId: this.selectBuild, //物件ID
        roomId: this.model.room_id, //部屋番号
        inDormitoryDate: this.in_dormitory_date, //入寮日
        userId: this.model.user_id, //ユーザID
      };
      return await this.roomWarningCheck(params);
    },
    //靴箱の使用状況をチェックし警告があれば取得する
    async shoeboxWarningCheck(params) {
      var retMsg; //戻り値（警告文）

      //警告文を取得
      await this.getRequest(
        "/dormitoryUserRevise/shoeboxWarningGet",
        params,
        this.$store.getters.getUserToken
      ).then((data) => {
        if (data.success) {
          retMsg = data.result;
        }
      });

      return retMsg;
    },
    //靴箱使用チェックハンドル
    async handleShoeboxWarningCheck() {
      let params = {
        buildingId: this.selectBuild, //物件ID
        shoeboxId: this.model.shoebox_id, //部屋番号
        inDormitoryDate: this.in_dormitory_date, //入寮日
        userId: this.model.user_id, //ユーザID
      };
      return await this.shoeboxWarningCheck(params);
    },
    //ICカードのidmをセット
    set_card_no(value) {
      this.model.card_no = value;
    },
    //認証キーをセット
    // set_auth_key(value) {
    //   this.model.auth_key = value;
    // },
    //idm読み込みスタート
    clickIcon() {
      this.$refs.card.proc();
    },
    // カード番号のセット
    setCardNo(value) {
      // console.log(value);
      this.model.card_no = value;
    },
    //部屋番号選択
    clickRoomSelect() {
      this.$refs.roomSelect.selectRooms();
    },
    //部屋番号のセッター
    setRoomIdByChild(obj) {
      this.model.room_id = obj.room_id;
    },
    //サブエントランス番号選択
    clickSubEntranceSelect() {
      this.$refs.subEntranceSelect.selectSubEntrance();
    },
    //サブエントランス番号のセッター
    setSubEntranceIdByChild(obj) {
      this.model.shoebox_id = obj.shoebox_id;
    },
    //寮生カード切り替え
    switchTenantData() {
      if (this.tenantInfoIdex + 1 < this.tenantInfoList.length) {
        this.tenantInfoIdex++;
      } else {
        this.tenantInfoIdex = 0;
      }
      this.setTenantMsg();
    },
    //寮生カードに表示するメッセージをセット
    setTenantMsg() {
      var today = new Date();
      var out_date = new Date(
        this.tenantInfoList[this.tenantInfoIdex].out_dormitory_date
      );
      var in_date = new Date(
        this.tenantInfoList[this.tenantInfoIdex].in_dormitory_date
      );
      if (out_date < today) {
        this.tenantCardMessage = "過去データです。";
      } else if (in_date > today) {
        this.tenantCardMessage = "入寮予定のデータです。";
      } else {
        this.tenantCardMessage = "";
      }
    },
    handleCancel() {
      this.close();
    },
    close() {
      this.$router.replace("/home");
    },
    open() {
      this.model.birthday = "";
      this.in_dormitory_date = "";
      this.out_dormitory_date = "";
      if (this.$refs.p2DialogForm) {
        this.$refs.p2DialogForm.reset();
        this.$refs.p2DialogForm.resetValidation();
      }
    },
    changeRequiredLabel() {
      if (this.selectUserClass == "3") {
        this.label_select_build = "*物件名";
        this.label_select_tenant = "*寮生区分";
        this.label_room_id = "*部屋番号";
        this.label_in_dormitory_date = "*入寮日";
      } else {
        this.label_select_build = "物件名選択";
        this.label_select_tenant = "寮生区分";
        this.label_room_id = "部屋番号";
        this.label_in_dormitory_date = "入寮日";
        if (this.selectUserClass == "2" || this.selectUserClass == "4") {
          this.label_select_group = "*対象物件グループ名";
        } else {
          this.label_select_group = "対象物件グループ名";
        }
      }
    },
  },
};
</script>

<style scoped>
.RiyoushaBox {
  margin: 8px;
  border: 1px solid rgb(147, 179, 204);
}

.radioBtn {
  margin-left: 20px;
  margin-top: -15px;
}

.roomid {
  padding-top: 20px;
}

.dateInout {
  padding-top: 22px;
}

.attention {
  margin: 8px 3px 8px 3px;
  font-size: 18px;
  color: red;
  justify-content: center;
}
</style>
